import { type DeviceEntity } from '@solinkcorp/api-types';
import React from 'react';
import useDevices from './useDevices';

export default function useDevicesFromSites(siteIds: readonly string[] = []) {
  const { devicesBySiteId } = useDevices();
  const devices = React.useMemo(
    () => getSiteDevices(siteIds, devicesBySiteId),
    [siteIds, devicesBySiteId],
  );

  const deviceIds = React.useMemo(() => devices.map((device) => device.id), [devices]);

  return { devices, deviceIds };
}

export function getSiteDevices(
  siteIds: readonly string[],
  devicesBySiteId: Record<string, DeviceEntity[]>,
) {
  return siteIds.flatMap((siteId) => devicesBySiteId[siteId]?.map((device) => device) ?? []);
}

export function getSiteDeviceIds(
  siteIds: string[],
  devicesBySiteId: Record<string, DeviceEntity[]>,
) {
  return siteIds.flatMap((siteId) => devicesBySiteId[siteId]?.map((device) => device.id) ?? []);
}
